import React from 'react'
import ProgressBar from "@ramonak/react-progress-bar"

export default function Progresbbar({Home , Away , Title , İmageSrc}) {

      const PercentageCal=(a,b)=> {
        return (b/ (a + b))*100;
      }

  return (
    <div className='ProgressbarContainer'>
        <div className='ProgressbarContainerText'>
          <div className='ProgresbarNumberText'>{Home}</div>
          <div className='ProgresbarTitleText'><img src={İmageSrc} className="ImageSrc"></img><span className='ProgressbarTitle'>{Title}</span></div>
          <div className='ProgresbarNumberText'>{Away}</div>
        </div>
       <ProgressBar className='ProgressBarStyle'  completed={Home == 0 && Away == 0 ? 50 :PercentageCal(Away,Home)} animateOnRender={true} bgColor="#262d47" height={"7px"} baseBgColor="#3e98c7" labelSize="0px"  />
    </div>
  
  )
}
